import { Injectable } from '@angular/core';
import { BaseResolver } from '@app/app.resolver';
import { ModelFactory } from '@app/models/core/model-factory';
import { TimeOffType } from '@app/models/time-off-v3/time-off-type.model';
import { TimeOffPolicy } from '@app/models/time-off-v3/time-off-policy.model';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';
import { TimeOffApprovalFlow } from '@models/time-off-v3/time-off-approval-flow.model';
import { TimeOffRequest } from '@models/time-off-v3/time-off-request.model';
import { ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class TimeOffV3Resolver extends BaseResolver {
    protected modelFactory: ModelFactory = new ModelFactory([
        {
            className: 'type',
            production: {
                find: (id: number) => {
                    return TimeOffType.find(id);
                },
            },
        },
        {
            className: 'policy',
            production: {
                find: (id: number) => {
                    return TimeOffPolicy.with([
                        'timeOffRequestRule',
                        'timeOffRequestRule.timeOffPolicy.timeOffType',
                        'timeOffSeniorityOverrides',
                        'timeOffApprovalFlow',
                    ]).find(id);
                },
            },
        },
        {
            className: 'work-schedule',
            production: {
                find: (id: number) => {
                    return WorkSchedule.find(id);
                },
            },
        },
        {
            className: 'approval-flow',
            production: {
                find: (id: number) => {
                    return TimeOffApprovalFlow.find(id);
                },
            },
        },
        {
            className: 'request',
            production: {
                find: (id: number) => {
                    return TimeOffRequest.queryParams('mark_notifications_as_read', true)
                        .with([
                            'employee',
                            'createdBy',
                            'timeOffRequestDays',
                            'timeOffPolicy.timeOffType',
                            'timeOffRequestApprovalFlow.forcedBy',
                            'timeOffRequestApprovalFlow.timeOffComment',
                            'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffApprovalFlowStep.timeOffApproverType',
                            'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffRequestApprovalFlow',
                            'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffRequestApprovals.approver',
                            'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowSteps.timeOffRequestApprovals.timeOffComment',
                            'timeOffRequestApprovalFlow.timeOffRequestApprovalFlowStepsWithTrashed',
                        ])
                        .find(id);
                },
            },
        },
    ]);
}
